import { useState } from "react";
import { Link } from "react-router-dom";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=DM+Sans:wght@300;400;500;600&display=swap');

  * { margin: 0; padding: 0; box-sizing: border-box; }

  .enrich-root {
    font-family: 'DM Sans', sans-serif;
    background: #fafafa;
    color: #1a1a1a;
    min-height: 100vh;
  }

  /* NAV */
  .nav {
    background: #111;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 48px;
    height: 64px;
    position: sticky;
    top: 0;
    z-index: 100;
  }
  .nav-logo { display: flex; flex-direction: column; line-height: 1; cursor: pointer; }
  .nav-logo-name {
    font-family: 'Playfair Display', serif;
    font-size: 26px; font-weight: 700; color: #fff; letter-spacing: 1px;
  }
  .nav-logo-name span { color: #e53935; }
  .nav-logo-tagline { font-size: 10px; color: #aaa; letter-spacing: 2px; margin-top: 2px; }
  .nav-links { display: flex; gap: 36px; list-style: none; }
  .nav-links a {
    color: #fff; text-decoration: none; font-size: 13px; font-weight: 500;
    letter-spacing: 1.5px; text-transform: uppercase; display: flex;
    align-items: center; gap: 7px; opacity: 0.85; transition: opacity 0.2s;
  }
  .nav-links a:hover { opacity: 1; }

  /* HERO BANNER */
  .tnc-hero {
    background: linear-gradient(135deg, #111 0%, #2a2a2a 60%, #1a1a1a 100%);
    padding: 60px 48px 50px;
    position: relative;
    overflow: hidden;
  }
  .tnc-hero::before {
    content: '';
    position: absolute;
    top: -60px; right: -60px;
    width: 340px; height: 340px;
    border-radius: 50%;
    background: radial-gradient(circle, #e5393522 0%, transparent 70%);
  }
  .tnc-hero::after {
    content: '';
    position: absolute;
    bottom: -80px; left: 30%;
    width: 280px; height: 280px;
    border-radius: 50%;
    background: radial-gradient(circle, #4a90d922 0%, transparent 70%);
  }
  .tnc-hero-inner { position: relative; z-index: 1; max-width: 860px; }
  .tnc-hero-eyebrow {
    font-size: 12px; font-weight: 600; letter-spacing: 3px;
    text-transform: uppercase; color: #e53935; margin-bottom: 14px;
  }
  .tnc-hero h1 {
    font-family: 'Playfair Display', serif;
    font-size: 48px; font-weight: 700; color: #fff;
    line-height: 1.15; margin-bottom: 16px;
  }
  .tnc-hero p {
    font-size: 15px; color: #aaa; line-height: 1.7; max-width: 580px;
  }
  .tnc-hero-meta {
    margin-top: 24px; display: flex; gap: 28px; flex-wrap: wrap;
  }
  .tnc-meta-pill {
    background: rgba(255,255,255,0.07);
    border: 1px solid rgba(255,255,255,0.12);
    border-radius: 99px; padding: 6px 16px;
    font-size: 12px; color: #ccc; letter-spacing: 0.5px;
  }

  /* LAYOUT */
  .tnc-layout {
    display: grid;
    grid-template-columns: 260px 1fr;
    gap: 0;
    max-width: 1200px;
    margin: 0 auto;
    padding: 48px 24px;
    align-items: start;
  }

  /* SIDEBAR */
  .tnc-sidebar {
    position: sticky;
    top: 88px;
    background: #fff;
    border-radius: 16px;
    border: 1.5px solid #e8e8e8;
    padding: 24px 0;
    overflow: hidden;
    box-shadow: 0 2px 16px rgba(0,0,0,0.05);
    margin-right: 32px;
  }
  .sidebar-title {
    font-size: 11px; font-weight: 600; letter-spacing: 2px;
    text-transform: uppercase; color: #999; padding: 0 20px 16px;
    border-bottom: 1px solid #f0f0f0;
  }
  .sidebar-nav { list-style: none; padding: 12px 0; }
  .sidebar-nav li a {
    display: block; padding: 9px 20px;
    font-size: 13.5px; color: #444; text-decoration: none;
    border-left: 3px solid transparent;
    transition: all 0.2s; line-height: 1.4;
  }
  .sidebar-nav li a:hover,
  .sidebar-nav li a.active {
    color: #e53935;
    border-left-color: #e53935;
    background: #fff5f5;
  }

  /* MAIN CONTENT */
  .tnc-content {
    background: #fff;
    border-radius: 16px;
    border: 1.5px solid #e8e8e8;
    padding: 48px 52px;
    box-shadow: 0 2px 16px rgba(0,0,0,0.05);
  }

  .tnc-section {
    margin-bottom: 52px;
    padding-bottom: 52px;
    border-bottom: 1px solid #f0f0f0;
  }
  .tnc-section:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  .section-number {
    font-size: 12px; font-weight: 700; letter-spacing: 2px;
    text-transform: uppercase; color: #e53935; margin-bottom: 10px;
  }

  .section-heading {
    font-family: 'Playfair Display', serif;
    font-size: 24px; font-weight: 700; color: #111;
    margin-bottom: 18px; line-height: 1.3;
  }

  .section-body {
    font-size: 14.5px; line-height: 1.85; color: #444;
  }
  .section-body p { margin-bottom: 14px; }
  .section-body p:last-child { margin-bottom: 0; }

  .tnc-list {
    list-style: none; margin: 14px 0;
  }
  .tnc-list li {
    display: flex; gap: 12px; align-items: flex-start;
    font-size: 14.5px; line-height: 1.75; color: #444;
    margin-bottom: 10px; padding: 12px 16px;
    background: #fafafa; border-radius: 10px;
    border-left: 3px solid #e53935;
  }
  .tnc-list li .bullet {
    color: #e53935; font-weight: 700; font-size: 16px; flex-shrink: 0; margin-top: 1px;
  }

  .tnc-callout {
    background: linear-gradient(135deg, #fff5f5 0%, #fff 100%);
    border: 1.5px solid #fca5a5;
    border-radius: 14px;
    padding: 20px 24px;
    margin: 18px 0;
    font-size: 14px;
    color: #7f1d1d;
    line-height: 1.7;
  }
  .tnc-callout strong { font-weight: 600; }

  .tnc-callout.blue {
    background: linear-gradient(135deg, #eff6ff 0%, #fff 100%);
    border-color: #93c5fd;
    color: #1e3a5f;
  }

  .tnc-callout.green {
    background: linear-gradient(135deg, #f0fdf4 0%, #fff 100%);
    border-color: #86efac;
    color: #14532d;
  }

  .tnc-table {
    width: 100%; border-collapse: collapse; margin: 18px 0;
    font-size: 14px;
  }
  .tnc-table th {
    background: #111; color: #fff; padding: 12px 16px;
    text-align: left; font-weight: 600; font-size: 12px;
    letter-spacing: 1px; text-transform: uppercase;
  }
  .tnc-table th:first-child { border-radius: 10px 0 0 0; }
  .tnc-table th:last-child { border-radius: 0 10px 0 0; }
  .tnc-table td {
    padding: 12px 16px; border-bottom: 1px solid #f0f0f0;
    vertical-align: top; line-height: 1.6; color: #444;
  }
  .tnc-table tr:last-child td { border-bottom: none; }
  .tnc-table tr:nth-child(even) td { background: #fafafa; }

  /* ACCEPTANCE BAR */
  .tnc-acceptance {
    background: #111;
    border-radius: 16px;
    padding: 28px 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    margin-top: 32px;
    flex-wrap: wrap;
  }
  .tnc-acceptance-text {
    font-size: 14px; color: #ccc; line-height: 1.6; max-width: 560px;
  }
  .tnc-acceptance-text strong { color: #fff; }
  .tnc-btn {
    background: #e53935;
    color: #fff; border: none; border-radius: 10px;
    padding: 13px 28px; font-size: 14px; font-weight: 600;
    cursor: pointer; letter-spacing: 0.5px;
    transition: background 0.2s, transform 0.15s;
    white-space: nowrap;
  }
  .tnc-btn:hover { background: #c62828; transform: translateY(-2px); }

  /* FOOTER */
  .footer {
    background: #111; color: #aaa;
    padding: 40px 48px;
    display: grid; grid-template-columns: 1fr 1fr 1fr 1fr; gap: 32px;
    margin-top: 40px;
  }
  .footer-brand p { margin-top: 12px; font-size: 13px; line-height: 1.7; }
  .footer-col h4 {
    color: #fff; font-size: 13px; font-weight: 600;
    letter-spacing: 1.5px; text-transform: uppercase; margin-bottom: 16px;
  }
  .footer-col ul { list-style: none; }
  .footer-col ul li { margin-bottom: 10px; font-size: 13px; cursor: pointer; transition: color 0.2s; }
  .footer-col ul li:hover { color: #fff; }
  .footer-bottom {
    background: #0a0a0a; color: #555;
    text-align: center; padding: 16px; font-size: 12px;
  }
`;

const sections = [
  {
    id: "acceptance",
    number: "01",
    title: "Acceptance of Terms",
    content: (
      <>
        <div className="section-body">
          <p>Welcome to Style Sutra Salon ("Style Sutra", "we", "us", or "our"). By accessing or using our website located at www.stylesutra.com (the "Site"), mobile applications, or any of our services, you agree to be bound by these Terms and Conditions ("Terms"). Please read these Terms carefully before using our services.</p>
          <p>If you do not agree to all the terms and conditions of this agreement, you may not access the website or use any services. These Terms apply to all visitors, users, and others who access or use our services.</p>
        </div>
        <div className="tnc-callout">
          <strong>Important:</strong> By creating an account, booking an appointment, purchasing a product, or enrolling in any Style Sutra loyalty program, you acknowledge that you have read, understood, and agree to be bound by these Terms and our Privacy Policy.
        </div>
      </>
    ),
  },
  {
    id: "services",
    number: "02",
    title: "Services & Appointments",
    content: (
      <>
        <div className="section-body">
          <p>Style Sutra provides premium beauty and wellness services including hair care, skin treatments, nail art, spa therapies, and related services through our salon network across India. Services are subject to availability and may vary by location.</p>
        </div>
        <ul className="tnc-list">
          <li><span className="bullet">→</span><span>Appointments can be booked online via our website or app, by phone at 1800-266-5300 (Toll Free), or in-salon at any Style Sutra location.</span></li>
          <li><span className="bullet">→</span><span>We recommend booking in advance, particularly for bridal packages, specialized treatments, and peak hours (weekends and holidays).</span></li>
          <li><span className="bullet">→</span><span>Style Sutra reserves the right to reschedule or cancel appointments in exceptional circumstances such as staff unavailability, salon closures, or unforeseen operational issues. You will be notified promptly and offered alternative slots.</span></li>
          <li><span className="bullet">→</span><span>Service pricing displayed on the Site is indicative and may vary by city, salon location, or promotional period. Final pricing will be confirmed at the time of service.</span></li>
          <li><span className="bullet">→</span><span>Style Sutra does not guarantee specific stylists or therapists, though we will make reasonable efforts to honour stylist preferences where possible.</span></li>
        </ul>
      </>
    ),
  },
  {
    id: "cancellation",
    number: "03",
    title: "Cancellation & Rescheduling Policy",
    content: (
      <>
        <div className="section-body">
          <p>We understand that plans change. Our cancellation policy is designed to be fair to both our clients and our salon professionals who reserve time specifically for your appointment.</p>
        </div>
        <table className="tnc-table">
          <thead>
            <tr>
              <th>Notice Given</th>
              <th>Cancellation Charge</th>
              <th>Points / Prepayment</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>More than 24 hours before</td>
              <td>No charge</td>
              <td>Full refund or transfer</td>
            </tr>
            <tr>
              <td>6–24 hours before</td>
              <td>25% of service value</td>
              <td>Partial credit to wallet</td>
            </tr>
            <tr>
              <td>Less than 6 hours before</td>
              <td>50% of service value</td>
              <td>No refund; credit available</td>
            </tr>
            <tr>
              <td>No-show (no cancellation)</td>
              <td>100% of service value</td>
              <td>No refund or credit</td>
            </tr>
          </tbody>
        </table>
        <div className="tnc-callout blue">
          <strong>Rescheduling:</strong> You may reschedule your appointment up to 12 hours before the scheduled time at no charge, subject to availability. Rescheduling with less than 12 hours' notice will be treated as a cancellation for the purposes of charges.
        </div>
      </>
    ),
  },
  {
    id: "membership",
    number: "04",
    title: "Membership & Loyalty Program",
    content: (
      <>
        <div className="section-body">
          <p>The Style Sutra Loyalty Program allows members to earn and redeem points on eligible services and product purchases. Membership is free and open to all customers upon registration.</p>
        </div>
        <ul className="tnc-list">
          <li><span className="bullet">→</span><span>Points are earned at a rate determined by Style Sutra and communicated on the Site. The current earn rate is typically 1 point per ₹1 spent on services and eligible products.</span></li>
          <li><span className="bullet">→</span><span>Points have no cash value and cannot be transferred, sold, or gifted to another member except through mechanisms explicitly provided by Style Sutra.</span></li>
          <li><span className="bullet">→</span><span>Style Sutra reserves the right to modify, suspend, or discontinue the loyalty program at any time with 30 days' prior notice to members.</span></li>
          <li><span className="bullet">→</span><span>Points may expire if your account is inactive (no earn or redeem transaction) for 12 consecutive months.</span></li>
          <li><span className="bullet">→</span><span>Fraudulent or abusive use of the loyalty program will result in forfeiture of all accrued points and termination of membership.</span></li>
          <li><span className="bullet">→</span><span>Special promotional offers (such as "Get 20% Points Back on Products") are subject to separate terms communicated at the time of the promotion and may have limited validity periods.</span></li>
        </ul>
      </>
    ),
  },
  {
    id: "products",
    number: "05",
    title: "Product Purchases & Returns",
    content: (
      <>
        <div className="section-body">
          <p>Style Sutra offers a curated range of premium beauty and hair care products through our salons and online store. All product purchases are subject to the following terms:</p>
        </div>
        <ul className="tnc-list">
          <li><span className="bullet">→</span><span>Products may be returned within 7 days of purchase if they are unused, in original sealed packaging, and accompanied by a valid receipt.</span></li>
          <li><span className="bullet">→</span><span>Opened, used, or damaged products cannot be returned or exchanged unless they are found to be defective or not as described.</span></li>
          <li><span className="bullet">→</span><span>Refunds on products will be processed to the original payment method within 7–10 business days. Points redeemed as part of a product purchase will be reversed to your account.</span></li>
          <li><span className="bullet">→</span><span>Style Sutra is not liable for adverse reactions to products. Clients with known allergies or sensitivities are advised to request a patch test before using any new product.</span></li>
        </ul>
        <div className="tnc-callout green">
          <strong>Patch Test Advisory:</strong> We strongly recommend a patch test 48 hours before any chemical treatment (colour, relaxer, keratin) or application of new skincare products, especially if you have sensitive skin or known allergies.
        </div>
      </>
    ),
  },
  {
    id: "payments",
    number: "06",
    title: "Payments & Pricing",
    content: (
      <>
        <div className="section-body">
          <p>Style Sutra accepts all major payment methods including credit/debit cards, UPI, net banking, digital wallets, and cash at salon. Online transactions are secured by SSL encryption.</p>
          <p>All prices displayed on the Site are inclusive of applicable GST unless stated otherwise. Style Sutra reserves the right to revise prices at any time without prior notice; however, any changes will not affect confirmed bookings where payment has been received.</p>
          <p>Gift cards and vouchers issued by Style Sutra are non-refundable and may not be redeemed for cash. They are subject to expiry dates as printed on the card and cannot be used in conjunction with other promotional offers unless explicitly stated.</p>
        </div>
      </>
    ),
  },
  {
    id: "conduct",
    number: "07",
    title: "Client Conduct & Safety",
    content: (
      <>
        <div className="section-body">
          <p>Style Sutra is committed to providing a safe, welcoming, and respectful environment for all clients and staff. All clients are expected to conduct themselves in a courteous and respectful manner at all times.</p>
        </div>
        <ul className="tnc-list">
          <li><span className="bullet">→</span><span>Style Sutra reserves the right to refuse service to any client who behaves in an abusive, threatening, or disruptive manner towards staff or other clients.</span></li>
          <li><span className="bullet">→</span><span>Clients must disclose any medical conditions, allergies, pregnancy, or skin conditions that may affect the suitability of services. Style Sutra shall not be liable for adverse outcomes resulting from undisclosed conditions.</span></li>
          <li><span className="bullet">→</span><span>Children under 12 must be accompanied by a parent or guardian. Style Sutra salons are not responsible for supervising unaccompanied minors.</span></li>
          <li><span className="bullet">→</span><span>Photography or video recording within the salon is permitted for personal use only. Commercial photography or filming requires prior written consent from Style Sutra management.</span></li>
        </ul>
      </>
    ),
  },
  {
    id: "liability",
    number: "08",
    title: "Limitation of Liability",
    content: (
      <>
        <div className="section-body">
          <p>To the fullest extent permitted by applicable law, Style Sutra Salon shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, goodwill, or other intangible losses.</p>
          <p>Style Sutra's total liability to you for any claims arising out of or related to these Terms or our services shall not exceed the amount you paid to Style Sutra in the 3 months preceding the event giving rise to the claim.</p>
          <p>Style Sutra does not guarantee that its website will be available at all times, free from viruses or errors. We make no warranties, express or implied, as to the accuracy or completeness of content on the Site.</p>
        </div>
        <div className="tnc-callout">
          <strong>Disclaimer:</strong> Results from beauty services and products vary from person to person. Style Sutra does not make guarantees regarding specific results of treatments, hair services, skin care procedures, or any other service offered.
        </div>
      </>
    ),
  },
  {
    id: "privacy",
    number: "09",
    title: "Privacy & Data Protection",
    content: (
      <>
        <div className="section-body">
          <p>Style Sutra collects, stores, and processes your personal data in accordance with our Privacy Policy, which is incorporated into these Terms by reference. By using our services, you consent to such processing.</p>
          <p>We collect personal information including your name, contact details, booking history, and payment information to provide and improve our services, send communications, and administer our loyalty program.</p>
          <p>Style Sutra does not sell your personal data to third parties. We may share data with trusted service providers who assist in operating our platform, subject to strict confidentiality obligations. You may request access to, correction of, or deletion of your personal data by contacting us at privacy@stylesutra.com.</p>
        </div>
      </>
    ),
  },
  {
    id: "amendments",
    number: "10",
    title: "Amendments & Governing Law",
    content: (
      <>
        <div className="section-body">
          <p>Style Sutra reserves the right to modify these Terms at any time. We will notify registered users of material changes via email or through a prominent notice on our Site. Your continued use of our services after changes are posted constitutes acceptance of the revised Terms.</p>
          <p>These Terms are governed by and construed in accordance with the laws of India. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the courts in Panchkula, Haryana, India.</p>
          <p>If any provision of these Terms is held to be invalid or unenforceable, the remaining provisions will continue in full force and effect.</p>
        </div>
        <div className="tnc-callout blue">
          <strong>Last Updated:</strong> These Terms and Conditions were last reviewed and updated in February 2025. For any questions, please contact our support team at support@enrichbeauty.com or call our toll-free number 1800-266-5300.
        </div>
      </>
    ),
  },
];

export default function EnrichTnC() {
  const [accepted, setAccepted] = useState(false);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="enrich-root">
      <style>{styles}</style>

      {/* NAV */}
      <nav className="nav">
        <Link to="/" style={{ textDecoration: "none" }}>
          <div className="nav-logo">
            <div className="nav-logo-name">Style <span>S</span>utra</div>
            <div className="nav-logo-tagline">where beauty meets elegance</div>
          </div>
        </Link>
        <ul className="nav-links">
          <li><a href="#">🛍 Services</a></li>
          <li><a href="#">🏪 Stores</a></li>
          <li><a href="#">📋 About Us</a></li>
        </ul>
      </nav>

      {/* HERO */}
      <div className="tnc-hero">
        <div className="tnc-hero-inner">
          <div className="tnc-hero-eyebrow">Legal</div>
          <h1>Terms &amp; Conditions</h1>
          <p>Please read these terms carefully before using Style Sutra's services, loyalty program, or making purchases through our website or salons.</p>
          <div className="tnc-hero-meta">
            <span className="tnc-meta-pill">📅 Last Updated: February 2025</span>
            <span className="tnc-meta-pill">🇮🇳 Governed by Indian Law</span>
            <span className="tnc-meta-pill">📍 Jurisdiction: Panchkula, Haryana</span>
          </div>
        </div>
      </div>

      {/* LAYOUT */}
      <div className="tnc-layout">

        {/* SIDEBAR */}
        <aside className="tnc-sidebar">
          <div className="sidebar-title">Contents</div>
          <ul className="sidebar-nav">
            {sections.map((s) => (
              <li key={s.id}>
                <a href={`#${s.id}`} onClick={(e) => { e.preventDefault(); scrollTo(s.id); }}>
                  <span style={{ color: "#e53935", fontWeight: 700, marginRight: 6 }}>{s.number}</span>
                  {s.title}
                </a>
              </li>
            ))}
          </ul>
        </aside>

        {/* CONTENT */}
        <main className="tnc-content">
          {sections.map((s) => (
            <div className="tnc-section" key={s.id} id={s.id}>
              <div className="section-number">Section {s.number}</div>
              <h2 className="section-heading">{s.title}</h2>
              {s.content}
            </div>
          ))}

          {/* ACCEPTANCE */}
          <div className="tnc-acceptance">
            <div className="tnc-acceptance-text">
              {accepted
                ? <><strong>✅ Thank you!</strong> You have accepted Style Sutra's Terms &amp; Conditions. You can now enjoy all our services and loyalty benefits.</>
                : <><strong>Ready to get started?</strong> By clicking "I Accept", you confirm that you have read and agree to all of Style Sutra's Terms &amp; Conditions and Privacy Policy.</>
              }
            </div>
            {!accepted && (
              <button className="tnc-btn" onClick={() => setAccepted(true)}>
                I Accept the Terms
              </button>
            )}
          </div>
        </main>
      </div>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-brand">
          <div className="nav-logo">
            <div className="nav-logo-name" style={{ color: "#fff" }}>Style <span style={{color:"#e53935"}}>S</span>utra</div>
            <div className="nav-logo-tagline" style={{fontSize:10,color:"#aaa",letterSpacing:2}}>where beauty meets elegance</div>
          </div>
          <p>SCO 16, Sector 2, Panchkula. Look good, feel great.</p>
        </div>
        <div className="footer-col">
          <h4>Services</h4>
          <ul>
            {["Hair", "Skin & Facials", "Body Treatments", "Nail Art", "Bridal Packages"].map(l => <li key={l}>{l}</li>)}
          </ul>
        </div>
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            {["Find a Salon", "Book Appointment", "Membership", "Gift Cards", "Privacy Policy"].map(l => <li key={l}>{l}</li>)}
          </ul>
        </div>
        <div className="footer-col">
          <h4>Connect</h4>
          <ul>
            {["Instagram", "Facebook", "YouTube", "Contact Us"].map(l => <li key={l}>{l}</li>)}
          </ul>
        </div>
      </footer>
      <div className="footer-bottom">© 2025 Style Sutra Salon. All rights reserved. | <Link to="/terms" style={{ color: "#888", textDecoration: "none" }}>Terms & Conditions</Link> | <Link to="/privacy" style={{ color: "#888", textDecoration: "none" }}>Privacy Policy</Link></div>
    </div>
  );
}